import React, { Component } from 'react'
import Switch from "react-switch";
import axios from 'axios';
import { getUser } from '../../../../actions/session';
import { SERVER_CREATED } from '../../../../config/rest_endpoints';
import { Notifications } from '../../../common/notification';


class AddServer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            ip: '',
            techPrefix:'',
            port:'5060',
            mask: '32',
            enforceOverRide: false,
            switched: true,
            userId: this.props.accountID,
            msg: '',
            isLoad:false
        }
        this.onHandleChange = this.onHandleChange.bind(this)
        this.onSubmitChange = this.onSubmitChange.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
        this.toggleSwitchEnforce = this.toggleSwitchEnforce.bind(this)
    }

    onHandleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    toggleSwitch() {
        this.setState({ switched: !this.state.switched })
    }

    clearForm() {
        this.setState({
            ip: '',
            switched: true,
        })
    }

    onSubmitChange() {
        const {ip, port, techPrefix, enforceOverRide, switched, User, userId,mask } = this.state
        const serverPlayload = {
            'ip': ip,
            'port': parseInt(port),
            'techPrefix' : techPrefix,
            'mask':parseInt(mask),
            'enforceOverRide': enforceOverRide,
            'enabled': switched
        }
        this.setState({isLoad:true})
        var headers = { "Authorization": "Bearer " + User.token };
        if ( ip == '') {
            console.log('fill form');
            Notifications.notify("One of form field is empty", "Error", "error")
            this.setState({isLoad:false})

        }
        else if (port == '') {
            Notifications.notify("One of form field is empty", "Error", "error")
            this.setState({isLoad:false})
        }
        else {
            axios.post(`${SERVER_CREATED}/${userId}/server/create`, serverPlayload, { headers }).then(res => {
                if (res) {
                    this.setState({
                        msg: res.data.message,
                        isLoad:false
                    })
                    this.props.close()
                    this.props.listingServer()
                    this.clearForm()
                    Notifications.notify(this.state.msg, "Created", "success")
                }
                else {
                    this.setState({
                        msg: res.data.message,
                        isLoad:false
                    })
                    Notifications.notify(this.state.msg, "error", "error")
                }
            }).catch(err => {
                var msessage = err.response.data.message
                console.log(`msessage`, msessage)
                Notifications.notify(msessage, "Failed", "error")
                this.setState({
                    isLoad:false
                })
            })
        }
    }

    toggleSwitchEnforce() {
        this.setState({ enforceOverRide: !this.state.enforceOverRide })
    }

    render() {
        const {ip, port,  techPrefix, enforceOverRide,switched,mask } = this.state
        console.log('port',port)
        return (
            <div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}}>Source IP</label>
                            <input type="email" className="form-control" name="ip" value={ip} onChange={this.onHandleChange} placeholder="Enter server ip" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}}>Tech Prefix</label>
                            <input type="email" className="form-control" name="techPrefix" value={techPrefix} onChange={this.onHandleChange} placeholder="Enter tech prefix" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}}>Mask</label>
                            <input type="number" className="form-control" name="mask" value={mask} onChange={this.onHandleChange} placeholder="Enter port" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}}>Port</label>
                            <input type="number" className="form-control" name="port" value={port} onChange={this.onHandleChange} placeholder="Enter port" />
                        </div>
                    </div>
                </div>
                {/* row */}
                <div className="form-group mt-1">
                    <div className="row">
                        <div className="col-md-3 mt-1">
                            <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14" >Enabled</label>
                        </div>
                        <div className="col-md-1 mr-3">
                            <Switch onChange={this.toggleSwitch} checked={switched} onColor="#00C292" />
                        </div>
                    </div>
                </div>
                <div className="form-group mt-1">
                    <div className="row">
                        <div className="col-md-3 mt-1">
                            <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14" >Enforce OverRide</label>
                        </div>
                        <div className="col-md-1 mr-3">
                            <Switch onChange={this.toggleSwitchEnforce} checked={enforceOverRide} onColor="#00C292" />
                        </div>
                    </div>
                </div>
                <div className="row" style={{borderTop:'1px solid #e9ecef'}}>
                    <div className="col-md-6 ml-auto">
                        <button type="submit " className="mt-2 main-button btn btn-sm btn-success float-right" disabled={this.state.isLoad ? true : false}  onClick={this.onSubmitChange} >
                             Add   {this.state.isLoad ? <i class="fas fa-spinner fa-spin ml-1"></i> : <i class="icon-file-plus ml-1 icon-1x"></i>} </button>
                    </div>
                </div>
            </div>
        )
    }
}
export default AddServer